import { css } from "@/utils/css";
import { formatTime } from "@/utils/format";
import { FaRegClock } from "react-icons/fa";

export function Pill({ children, className, ...props }: React.PropsWithChildren<React.HTMLAttributes<HTMLSpanElement>>) {
    return (
        <span className={css("pill", className || "")} {...props}>
            {children}
        </span>
    );
}

export function TimePill({ hour, minute }: { hour: number; minute: number }) {
    const formattedTime = formatTime(hour, minute);

    return (
        <Pill className={css("flex items-center gap-1")}>
            <FaRegClock />
            <span>{formattedTime}</span>
        </Pill>
    );
}
